import {
  App
} from './.request-address.js'
import request from './.request-cloud.js'

/***
 * 查询设备的动态地址
 * */
export function searchUrl(sn) {
  return request({
    url: `/device-controller/${sn}?of=device_url`,
    method: 'get',
  })
}

/**
 * 环境监控动态设置地址路径
 * */
export function getEquipData(baseurl) {
  const app = new App(baseurl)
  return app.request({
    method: 'get'
  })
}

/**
 * 环境监控控制开关
 * */
export function changeControl(baseurl, id,sn) {
  const app = new App(baseurl)
  return app.request({
    url: `?of=relay&state=${id}&sn=${sn}`,
    method: 'put'
  })
}


/**
   * 环境监控控制开关---草莓小镇
   * */
 export function changeControlCMXZ(baseurl) {
  const app = new App(baseurl)
  return app.request({
   
    method: 'put'
  })
}


// WEBPACK FOOTER //
// ./src/api/equipControl.js